export default __webpack_public_path__ + "static/media/03.9d08f483.png";